import React, { useState } from 'react';
import styled from 'styled-components';

const StyledToggleButton = styled.button`
  background-color: ${(props) => (props.isToggled ? '#698d51' : '#93c572')};
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.2s ease;
  margin-bottom: ${(props) => props.marginBottom};
  padding: 11px 20px;
  margin-right: 10px;
  box-shadow: ${(props) =>
    props.isToggled ? 'inset 2px 2px 5px rgba(0, 0, 0, 0.2)' : 'none'};

  &:hover {
    background-color: ${(props) => (props.isToggled ? '#4f7042' : '#698d51')};
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const ToggleButton = ({ initialToggled = false, disabled = false, onToggle, children, marginBottom = '-7px' }) => {
  const [isToggled, setIsToggled] = useState(initialToggled);

  const handleClick = () => {
    const newToggledState = !isToggled;
    setIsToggled(newToggledState);
    if (onToggle) onToggle(newToggledState);
  };

  return (
    <StyledToggleButton isToggled={isToggled} onClick={handleClick} disabled={disabled} marginBottom={marginBottom}>
      {children || (isToggled ? 'Toggled On' : 'Toggled Off')}
    </StyledToggleButton>
  );
};

export default ToggleButton;
